import { createRoot } from 'react-dom/client';

import { CommonEntrypoint } from '../common/common-entrypoint.tsx';

import '../../src/styles/apolloreading.css';

createRoot(document.getElementById('root')!).render(<CommonEntrypoint />);
